"use strict";
var QuillDeltaToHtmlConverter_1 = require("./QuillDeltaToHtmlConverter");
module.exports = QuillDeltaToHtmlConverter_1.QuillDeltaToHtmlConverter;



//////////////////
// WEBPACK FOOTER
// ./~/quill-delta-to-html/dist/commonjs/main.js
// module id = 16
// module chunks = 0